import { Component } from 'react/index.js';
import { connect } from 'react-redux';

import firebase from 'firebase/app';

import { withRouter } from 'react-router-dom';

import { appDone,
         appSetRoute } from '../../store/actions/app.js';

import { dialogOpen, 
         dialogClose } from '../../store/actions/msgDialog.js';

import { loginError,
         loginSuccess,
         logoutCancel,
         logoutConfirmed } from '../../store/actions/login.js';

import { profileUpdate } from '../../store/actions/profile.js';

class ServLogin extends Component{
    constructor(props){
        super(props);

//*** Methods
        this._loginRequest = this._loginRequest.bind(this);
        this._logoutConfirmed = this._logoutConfirmed.bind(this);
        this._logoutCancel = this._logoutCancel.bind(this);
    }

    componentDidUpdate(){
        this._handleUpdate();
    }

    render(){
        return null;
    }

    //********************************
    _handleUpdate(){        
        switch (this.props.loginState) {
            case 1:
                this._loginRequest();
                break;

            case 4:
                this._logoutRequest();
                break;

            case 5:
                this._logoutConfirmed();
                break;

            default:
                break;
        }
    }

    async _loginRequest(){
        const that = this;

        //Automatic sigin if available
        let loginData = JSON.parse(localStorage.getItem('loginData'));
        if (loginData){
            const qsnap = await firebase.firestore().collection("users")
                .where('user','==',loginData.user.email)
                .get();

            if (qsnap && qsnap.docs.length > 0){
                let userData = qsnap.docs[0].data();

                this.props.profileUpdate(userData);
                this.props.loginSuccess();
                this.props.appDone();
                this.props.appSetRoute('plate');
                return true;
            } else {
                localStorage.removeItem('loginData');
                localStorage.removeItem('delapp-plate');
                window.location.replace("/");
                window.location.reload(true);
            }
        }

        //Request Signin
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
            .then(()=>{            
            return firebase.auth()
                .signInWithEmailAndPassword(this.props.user, this.props.pswd);

        }).then(async user => {
            localStorage.setItem('loginData', JSON.stringify(user));

            const qsnap = await firebase.firestore().collection("users")
                .where('user','==',that.props.user)
                .get();

            if (qsnap.docs.length === 0){
                throw new Error('Invalid user.');
            }

            let userData = qsnap.docs[0].data();

            that.props.profileUpdate(userData);
            that.props.loginSuccess();
            that.props.appDone();
            that.props.appSetRoute('plate');
        }).catch(err=>{
            console.log(err);
            that.props.loginError();            
            that.props.appDone();   
        });
    }

    _logoutRequest(){
        this.props.dialogOpen({
            header: this.props.txt_confirm,
            body: this.props.txt_logout + '?',
            btn1: this._logoutConfirmed,
            btn1Txt: this.props.txt_yes,
            btn2: this._logoutCancel,
            btn2Txt: this.props.txt_no
        });
    }

    _logoutConfirmed(){
        firebase.auth().signOut();
        setTimeout(()=>{
            // window.persistor.flush();
            // window.persistor.purge();
            localStorage.removeItem('loginData');
            localStorage.removeItem('delapp-plate');
            window.location.replace("/");
            window.location.reload(true);
        },500);
    }

    _logoutCancel(){
        this.props.logoutCancel();
        this.props.dialogClose();
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        loginState: state.login.loginState,
        pswd : state.login.pswd,
        user : state.login.user,

        txt_confirm: getText("0030"),
        txt_yes: getText("0031"),
        txt_no: getText("0032"),
        txt_logout: getText("0033")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appDone: () => dispatch(appDone()),
        appSetRoute: (route) => dispatch(appSetRoute(route)),

        dialogOpen: (data) => dispatch(dialogOpen(data)),
        dialogClose: () => dispatch(dialogClose()),

        loginError: () => dispatch(loginError()),
        loginSuccess: () => dispatch(loginSuccess()),
        logoutConfirmed: () => dispatch(logoutConfirmed()),
        logoutCancel: () => dispatch(logoutCancel()),

        profileUpdate: (data) => dispatch(profileUpdate(data))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(ServLogin));


// WEBPACK FOOTER //
// ./src/containers/Cservices/ServLogin.js